import React, { useState } from "react";
// Components
import { Col, Row, Form, message } from "antd";
import { CustomButton, CustomInput } from "../../components";
import { SignUpUser } from "../../api's/auth.js";
import { useNavigate } from "react-router-dom";
import { useSpin } from "../../components/SpinContext";



const SignupForm = () => {
  const { showSpin, hideSpin } = useSpin();
  const [form] = Form.useForm();
  const [isFormValid, setIsFormValid] = useState(false);
  const navigate = useNavigate();

  const onFinish = (values) => {
    if (values && Object.keys(values).length > 0) {
      setIsFormValid(true);
      showSpin();
      SignUpUser(values)
        .then((res) => {
          if (res?.data?.data?.is_success) {
            navigate("/verify-email", { state: values });
          } else {
            message.error(res?.data?.data?.message);
          }
        })
        .catch((error) => {
          console.log(error)
        }).finally(() => {
          hideSpin();
          setIsFormValid(false);
        });
    }
  };

  const handleClick = () => {
    navigate("/login")
  }


  return (
    <>
      <Form form={form} name="signupForm" layout="vertical" onFinish={onFinish} autoComplete="off">
        <Row gutter={[16, 24]}>
          <Col xl={12} lg={12} md={12} sm={12} xs={24}>
            <Form.Item
              className="custom-input"
              label="Your name"
              name="name"
              rules={[
                { required: true, message: "Please enter your name" },
                {
                  type: "string",
                  min: 3,
                  message: "Name must be at least 3 characters long",
                },
              ]}
              style={{ marginBottom: "0px" }}
            >
              <CustomInput
                placeholder="Enter name"
                height="36px"
                border="0px"
                bgColor="#F3F3F3"
                textColor="#5E5E5E"
                borderRadius="8px"
                placeholderColor="#5E5E5E"
                lineHeight="38px"
              />
            </Form.Item>
          </Col>

          <Col xl={12} lg={12} md={12} sm={12} xs={24}>
            <Form.Item
              label="Your email"
              name="email"
              rules={[
                { required: true, message: "Please enter your email" },
                { type: "email", message: "Enter Valid Email Only" },
              ]}
              style={{ marginBottom: "0px" }}
            >
              <CustomInput
                placeholder="Enter email"
                height="36px"
                border="0px"
                bgColor="#F3F3F3"
                textColor="#5E5E5E"
                borderRadius="8px"
                placeholderColor="#5E5E5E"
                lineHeight="38px"
              />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label="Company name"
              name="company_name"
              rules={[
                { required: true, message: "Please enter your company name" },
                {
                  type: "string",
                  min: 3,
                  message: "Company name must be at least 3 characters long",
                },
              ]}
            >
              <CustomInput
                placeholder="Enter company name"
                height="36px"
                border="0px"
                bgColor="#F3F3F3"
                textColor="#5E5E5E"
                borderRadius="8px"
                placeholderColor="#5E5E5E"
                lineHeight="38px"
                width="100%"
              />
            </Form.Item>
          </Col>

          <Col span={24}>
            <CustomButton
              text="Get Started"
              block="block"
              height="36px"
              bgColor="#000"
              color="#fff"
              borderRadius="8px"
              isFormValid={isFormValid}
              htmlType="submit"
              fontSize={14}
              fontWeight={500}
            />
          </Col>
        </Row>
      </Form>

      <Row justify="center" align="middle" style={{ marginTop: "20px" }}>
        <Col>
          {/* <a href="/login">Already have an account?</a> */}
          <p 
            style={{ fontSize: "14px", fontWeight: "400", lineHeight: "20px", color: "#5E5E5E" }}
          >
            Already have an account? <span onClick={handleClick} style={{ cursor: "pointer" }}>Login</span>
          </p>
        </Col>
      </Row>
    </>
  );
};

export default SignupForm;
